import { createReducer, on } from '@ngrx/store';
import { ViewStateSortOders } from '@src/suite/common/enums/viewstate-sort-orders';

import { PSTFieldNames } from '../../data-models/fields/pst-field-names';
import { NotesActions, NotesApiActions } from './notes.actions';
import { NotesNewRecordState, NotesState } from './notes.models';

export const initialNotesState: NotesState = {
    selectedNoteId: null,
    filter: {},
    searchTherm: null,
    sort: {
        sortBy: PSTFieldNames.CreatedDateTime,
        sortOrder: ViewStateSortOders.DESC,
    },
};

export const notesReducer = createReducer(
    initialNotesState,
    on(NotesActions.selectNote, (state, { noteId }): NotesState => {
        return { ...state, selectedNoteId: noteId };
    }),
    on(NotesActions.openEditNote, (state, action): NotesState => {
        return {
            ...state,
            selectedNoteId: action?.record?.Guid,
        };
    }),
    on(NotesActions.closeEditNote, (state): NotesState => {
        return {
            ...state,
            selectedNoteId: null,
        };
    }),
    on(NotesActions.resetState, (): NotesState => {
        return {
            ...initialNotesState,
        };
    }),
    on(NotesActions.initializeNotesFilter, (state, action): NotesState => {
        return {
            ...state,
            filter: action.filter,
        };
    }),
    on(NotesActions.updateNotesFilter, (state, action): NotesState => {
        return {
            ...state,
            filter: action.filter,
        };
    }),
    on(NotesActions.changeSearchTerm, (state, action): NotesState => {
        return {
            ...state,
            searchTherm: action.searchTerm,
        };
    }),
    on(NotesActions.changeSort, (state, action): NotesState => {
        return {
            ...state,
            sort: { ...action.sort },
        };
    })
);

export const newNoteState: NotesNewRecordState = {
    record: null,
    recordTemplateGuid: null,
    recordCreating: false,
};

export const notesNewRecordReducer = createReducer(
    newNoteState,
    on(NotesActions.openCreateNewNote, (state, action): NotesNewRecordState => {
        return {
            ...state,
            record: action.newRecord,
            recordCreating: false,
        };
    }),
    on(NotesActions.selectRecordTemplateGuid, (state, action): NotesNewRecordState => {
        return {
            ...state,
            recordTemplateGuid: action.templateGuid,
        };
    }),
    on(NotesActions.resetNewNoteState, (): NotesNewRecordState => {
        return {
            ...newNoteState,
        };
    }),
    on(NotesApiActions.createNote, (state): NotesNewRecordState => {
        return {
            ...state,
            recordCreating: true,
        };
    }),
    on(NotesApiActions.createNoteDone, (state): NotesNewRecordState => {
        return {
            ...state,
            recordCreating: false,
        };
    }),
    on(NotesActions.openEditNote, (state): NotesNewRecordState => {
        return {
            ...state,
            record: null,
        };
    })
);
